/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper, { Navigation, Pagination } from "swiper";
Swiper.use([Navigation,Pagination]);


export function slider() {
    const testimonialSliderSelector = ".testimonials-slider--slider";

    const init = function () {
        var testimonialSlider = new Swiper(testimonialSliderSelector,
            {
                speed:500,
                loop: false,
                navigation: {
                    prevEl: '.testimonials-slider--slider__navigation > .button-prev',
                    nextEl: '.testimonials-slider--slider__navigation > .button-next'
                },
                pagination: {
                    el: '.testimonials-slider--slider__navigation > .pagination',
                    type:'fraction'
                }
            });
    };



    init();
}